function handleSubmenusNearEdge() {
	const submenuParents = document.querySelectorAll(
		".desktop-nav nav .has-submenu ul .has-submenu"
	);

	submenuParents.forEach((parentElement, index) => {
		const submenu = parentElement.querySelector("ul");

		const checkEdge = () => {
			if (!parentElement.classList.contains("near-edge")) {
				const rect = submenu.getBoundingClientRect();
				const viewportWidth = typeof window !== "undefined" ? window.innerWidth : 1080;
				rect.right > viewportWidth && parentElement.classList.add("near-edge");
			}
		};

		parentElement.addEventListener("mouseenter", checkEdge);
	});
}

export default handleSubmenusNearEdge;
